export default "__VITE_ASSET__62d71813__"